<template>
	<div class="mobfooter_wrap">
		<div class="mobfooter_cont">
			<div class="mobfooter_title">LaLANITAplus</div>
			<div class="mobfooter_list">
				<div class="mobfooter_items scale-1px-home" @click="gotoPrivacy">
					<div class="mobfooter_ileft" :class="isPrivacy ? 'mobfooter_ileft_active' : ''">Aviso de Privacidad (Android)</div>
					<div class="mobfooter_iright">
						<img src="@/assets/mobimg/mobfooter_arrow.png" />
					</div>
				</div>
				<div class="mobfooter_items scale-1px-home" @click="gotoPrivacyAgreement">
					<div class="mobfooter_ileft" :class="isPrivacyAgreement ? 'mobfooter_ileft_active' : ''">Aviso de Privacidad (iOS)</div>
					<div class="mobfooter_iright">
						<img src="@/assets/mobimg/mobfooter_arrow.png" />
					</div>
				</div>
				<div class="mobfooter_items scale-1px-home" @click="gotoProvision">
					<div class="mobfooter_ileft" :class="isProvision ? 'mobfooter_ileft_active' : ''">Términos y Condiciones</div>
					<div class="mobfooter_iright">
						<img src="@/assets/mobimg/mobfooter_arrow.png" />
					</div>
				</div>
			</div>
			<!--<div class="mobfooter_middle">
				<div class="mobfooter_title">Sitios de referencia</div>
				<div class="mobfooter_mimg">
					<img src="@/assets/mobimg/mobfooter_logo.png" />
				</div>
			</div>-->
			<div class="mobfooter_down">
				<div class="mobfooter_title">Contáctanos</div>
				<div class="mobfooter_dlist">
					<div class="mobfooter_dlitem">Atención al clientes：5590599377</div>
					<!--<div class="mobfooter_dlitem"></div>-->
					<div class="mobfooter_dlitem">Correo electrónico：servicioplus@lalanitaplus.com</div>
				</div>
			</div>

			<div class="footer_lalanita_1vdrigt">
				<div class="footer_lalanita_1vdr_v">
					<a
							href="https://www.facebook.com/profile.php?id=61583928676835"
							target="_blank"
							class="playBtn"
					>
						<div class="footer_lalanita_1vdr_vmg">
							<img src="../assets/imgs/facebook_2.webp" alt="">
						</div>
					</a>
					<a
							href="https://www.instagram.com/lalanitaplus?igsh=cngyMjZpNWN2emF5"
							target="_blank"
							class="playBtn"
					>
						<div class="footer_lalanita_1vdr_vmg">
							<img src="../assets/imgs/instagram_2.webp" alt="">
						</div>
					</a>
					<a
							href="https://www.tiktok.com/@lalanitaplus?_r=1&_t=ZS-91fhCwGKPCe"
							target="_blank"
							class="playBtn"
					>
						<div class="footer_lalanita_1vdr_vmg">
							<img src="../assets/imgs/tiktok_2.webp" alt="">
						</div>
					</a>
					<a
							href="https://www.youtube.com/@LaLanitaPlus"
							target="_blank"
							class="playBtn"
					>
						<div class="footer_lalanita_1vdr_vmg">
							<img src="../assets/imgs/youtube.webp" alt="">
						</div>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'mobfooter',
		data() {
			return {
				isPrivacy: false,
				isPrivacyAgreement: false,
				isProvision: false,
			}
		},
		created() {},
		mounted() {
			let usePath = this.$route.path

			if (usePath.indexOf('privacy') != -1) {
				this.isPrivacy = true
			} else {
				this.isPrivacy = false
			}

			if (usePath.indexOf('pricacyagreement') != -1) {
				this.isPrivacyAgreement = true;
			} else {
				this.isPrivacyAgreement = false;
			}

			if (usePath.indexOf('provision') != -1) {
				this.isProvision = true
			} else {
				this.isProvision = false
			}
		},
		methods: {
			gotoPrivacy() {
				this.$router.push({
					path: '/privacy',
				})
			},
			gotoPrivacyAgreement() {
				this.$router.push({
					path: '/pricacyagreement',
				})
			},
			gotoProvision() {
				this.$router.push({
					path: '/provision',
				})
			},
		},
	}
</script>

<style></style>
